export const transformDetailWithPhone = (detail) => {
	const detailTransform = detail.trim().split(/[ ,.\n]+/)
	const regexPhoneNumber = /(84|0[3|5|7|8|9])+([0-9]{8})\b/
	const regexOnlyNumber = /^[0-9]*$/

	for (const item of detailTransform) {
		if (regexPhoneNumber.test(item) && regexOnlyNumber.test(item) && item.length === 10) {
			detail = detail.replace(item, `<a href="tel:${item}">${item}</a>`)
		}
	}
	return detail
}

export const transformDetailWithLink = (detail) => {
	const regexLink = /(https?:\/\/[^\s]+)/g
	return detail.replace(regexLink, '<a href="$1" target="_blank">$1</a>')
}
